import { atom } from 'jotai';

export interface AddExternalRoleFormData {
  name: string;
  permissions: Record<string, boolean>;
}

const getInitialFormData = (): AddExternalRoleFormData => ({
  name: '',
  permissions: {},
});

export const $addExternalRoleDialogOpen = atom(false);
export const $addExternalRoleFormData =
  atom<AddExternalRoleFormData>(getInitialFormData());

export const $openAddExternalRoleDialog = atom(null, (_get, set) => {
  set($addExternalRoleFormData, getInitialFormData());
  set($addExternalRoleDialogOpen, true);
});

export const $closeAddExternalRoleDialog = atom(null, (_get, set) => {
  set($addExternalRoleDialogOpen, false);
  set($addExternalRoleFormData, getInitialFormData());
});

export const $updateAddExternalRoleForm = atom(
  null,
  (get, set, update: Partial<AddExternalRoleFormData>) => {
    set($addExternalRoleFormData, {
      ...get($addExternalRoleFormData),
      ...update,
    });
  },
);

export const $updateAddExternalRolePermission = atom(
  null,
  (get, set, update: { key: string; enabled: boolean }) => {
    const form = get($addExternalRoleFormData);
    set($addExternalRoleFormData, {
      ...form,
      permissions: {
        ...form.permissions,
        [update.key]: update.enabled,
      },
    });
  },
);

export const $bulkUpdateAddExternalRolePermissions = atom(
  null,
  (get, set, updates: Record<string, boolean>) => {
    const form = get($addExternalRoleFormData);
    set($addExternalRoleFormData, {
      ...form,
      permissions: {
        ...form.permissions,
        ...updates,
      },
    });
  },
);

export const $addExternalRoleFormValid = atom((get) => {
  const form = get($addExternalRoleFormData);
  return form.name.trim() !== '';
});

export const $addExternalRoleEnabledPermissionKeys = atom((get) => {
  const form = get($addExternalRoleFormData);
  return Object.entries(form.permissions)
    .filter(([, enabled]) => enabled)
    .map(([key]) => key);
});
